import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEVICE_RECHARGE_CONFIG_DETAIL',
        create: 'DEVICE_RECHARGE_CONFIG_CREATE',
        update: 'DEVICE_RECHARGE_CONFIG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'app_id',
        default: '',
        label: 'app_id',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.app_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'key',
        default: '',
        label: 'key',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "key", $$v);
              }
            }
          });
        }
      }, {
        prop: 'url',
        default: '',
        label: 'url',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "url", $$v);
              }
            }
          });
        }
      }];
    }
  }
};